module.exports = __webpack_public_path__ + "img/t2.a16aa633.jpg";